import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  commonError$ = new Subject<void>();

  error$ = new BehaviorSubject('');

  showCommonError() {
    this.commonError$.next();
  }

  setError(error = '') {
    this.error$.next(error);
  }
}
